import { HeartHandshake, Compass, Globe2, ShieldCheck } from "lucide-react";
import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/layout/PageHero";
import { SectionHead, Reveal } from "@/components/layout/Motion";
import { CallButton } from "@/components/layout/CallButton";
import { BRAND, COMPANY } from "@/lib/site";

const VALUES = [[HeartHandshake, "Human-first travel", "Every booking is handled by a real specialist from first call through post-trip. No bots, no call menus."], [Compass, "Thoughtful curation", "We plan around your pace, preferences and budget — not around algorithms or sponsored placements."], [Globe2, "Global reach", "Access to major U.S. and international carriers, plus hotel and ground partners through our partner networks."], [ShieldCheck, "Expert-led service", "Experienced travel advisors, secure card processing and 24/7 toll-free phone support."]];

export default function About() {
  return (
    <Layout>
      <PageHero testId="about-hero" compact crumb="About us" line1="An independent" line2="global travel team." text="Real people helping you plan flights, stays and holidays — one conversation at a time." />
      <section className="bg-white py-16">
        <div className="mx-auto grid max-w-[1320px] gap-10 px-4 sm:px-8 lg:grid-cols-2">
          <Reveal className="space-y-4 text-slate-700">
            <p>{BRAND} is a travel brand operated under {COMPANY}, providing global travel booking services including flights, hotels, car rentals, cruises and holiday packages through partner networks.</p>
            <p>We operate as an independent travel agency and are not affiliated with airlines or hotel brands mentioned on this website. All trademarks belong to their respective owners.</p>
            <p>Our team of travel specialists answers calls themselves — with operational presence in India and the United States, and partner support around the clock.</p>
          </Reveal>
          <Reveal className="overflow-hidden rounded-2xl"><img src="/img/elfs-flight-deals-hero.webp" alt="Aircraft above the clouds" className="h-full w-full object-cover" /></Reveal>
        </div>
      </section>
      <section className="bg-sand py-16">
        <div className="mx-auto max-w-[1320px] px-4 sm:px-8">
          <SectionHead title="Four quiet commitments we keep for every traveler." />
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map(([Icon, t, x], i) => <Reveal key={t} delay={i * 0.06} className="rounded-2xl bg-white p-6"><Icon className="h-7 w-7 text-coral" /><h3 className="mt-4 font-display font-bold text-ink">{t}</h3><p className="mt-2 text-sm text-slate-600">{x}</p></Reveal>)}
          </div>
        </div>
      </section>
      <section className="bg-ink py-16 text-white">
        <Reveal className="mx-auto max-w-3xl px-4 text-center">
          <h2 className="font-display text-3xl font-bold">Every great trip starts with a call.</h2>
          <p className="mt-3 text-white/80">Whether you're planning a weekend getaway or a round-the-world journey, we'd love to help. No script, no pressure, no obligation.</p>
          <div className="mt-8 flex justify-center"><CallButton testId="about-call" showNumber size="lg" /></div>
        </Reveal>
      </section>
    </Layout>
  );
}
